import { render, staticRenderFns } from "./NoMRNIcon.vue?vue&type=template&id=2c803f7e&"
import script from "./NoMRNIcon.vue?vue&type=script&lang=js&"
export * from "./NoMRNIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports